<template lang="pug">
shListData(title="Casos de fraude activos" resolver="fraudCases" keyData="_id" component="shFraudCase")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'FraudCases',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fraudCase/FraudCases.vue